import React, { Component } from 'react';
import styled from 'styled-components';
import { BarTrack, BarFill } from './DashboardPanel';
import { fmt } from '../model/dashboardCalc';

// 항목별 가로 막대 목록 (items: [[name, value]], digits: 수치 소수점 자리수, showRate: 수치 옆 비율(%) 표시)
class BarList extends Component {
  render() {
    const { items, total, digits = 1, showRate = false } = this.props;

    return (
      <List>
        {items.map(([name, val]) => {
          const rate = total ? (val / total) * 100 : 0;
          return (
            <Row key={name} className={showRate ? 'with-rate' : ''}>
              <span>{name}</span>
              <BarTrack>
                <BarFill style={{ width: `${rate}%` }} />
              </BarTrack>
              <span className="value">
                {fmt(val, digits)}
                {showRate && <small> ({fmt(rate, 1)}%)</small>}
              </span>
            </Row>
          );
        })}
      </List>
    );
  }
}

const List = styled.div`
  display: grid;
  gap: 12px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr 65px;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #a8b9d0;

  .value {
    text-align: right;
    white-space: nowrap;
    color: #d8e7f8;

    small {
      font-size: 11px;
      color: #849bb9;
    }
  }
  &.with-rate {
    grid-template-columns: 72px 1fr 128px;
  }

  @media (max-width: 700px) {
    grid-template-columns: 52px 1fr 54px;
    gap: 8px;

    &.with-rate {
      grid-template-columns: 52px 1fr 108px;
    }
  }
`;

export default BarList;
